const ROOT = 'Login/login/password';

export const FETCH_RECOVER_PASSWORD_REQUEST = `${ROOT}/FETCH_RECOVER_PASSWORD_REQUEST`;
export const FETCH_RECOVER_PASSWORD_SUCCESS = `${ROOT}/FETCH_RECOVER_PASSWORD_SUCCESS`;
export const FETCH_RECOVER_PASSWORD_FAILURE = `${ROOT}/FETCH_RECOVER_PASSWORD_FAILURE`;
